import { webTitle } from "@/config/index";
import storage from "@/utils/storage";
import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  /**网页不能回退-1*/
  scrollBehavior: () => {
    history.pushState(history.state, "", document.URL);
  },

  /**linkActiveClass: "aaa",*/

  routes: [
    {
      name: "login",
      path: "/login",
      component: () => import("@/views/login/LoginPage.vue"),
      meta: { title: "物流小土豆" },
    },
    {
      name: "error-page",
      path: "/error-page",
      component: () => import("@/views/ErrorPage.vue"),
      meta: { title: webTitle + " / 页面出错了" },
    },
    {
      name: "not-page",
      path: "/:pathMatch(.*)*",
      component: () => import("@/views/NotPage.vue"),
      meta: { title: webTitle + " / 页面不存在" },
    },
    /**客户管理*/
    {
      name: "/AdminPage",
      path: "/admin-page",
      component: () => import("@/views/admin/index/IndexPage.vue"),
      children: [
        {
          name: "MemberPage",
          path: "/member-page",
          component: () => import("@/views/admin/member/ViewPage.vue"),
          meta: { title: webTitle + " / 管理员 / 客户信息" },
        }, //,meta:{keepAlive:true,isBack:false}
        {
          name: "UserList",
          path: "/user-list",
          component: () => import("@/views/admin/user/UserList.vue"),
          meta: { title: webTitle + " / 管理员 / 用户信息" },
        },
        {
          name: "ViewOrderList",
          path: "/view-order-list",
          component: () => import("@/views/admin/userview/ViewOrderList.vue"),
          meta: { title: webTitle + " / 管理员 / 查看托单" },
        },
        {
          name: "SerialList",
          path: "/serial-list",
          component: () => import("@/views/admin/serial/SerialList.vue"),
          meta: { title: webTitle + " / 管理员 / 序列号" },
        },
        {
          name: "LogMemberLoginList",
          path: "/log-member-login-list",
          component: () => import("@/views/admin/log/LoginList.vue"),
          meta: { title: webTitle + " / 管理员 / 登录日志" },
        },
        {
          name: "LogMemberUpdatePasswordList",
          path: "/log-member-update-password-list",
          component: () => import("@/views/admin/log/UpdatePasswordList.vue"),
          meta: { title: webTitle + " / 管理员 / 更新密码日志" },
        },
        {
          name: "LogMemberUpdateUserList",
          path: "/log-member-update-user-list",
          component: () => import("@/views/admin/log/UpdateUserList.vue"),
          meta: { title: webTitle + " / 管理员 / 更新用户日志" },
        },
        {
          name: "LogMemberUpdateRightList",
          path: "/log-member-update-right-list",
          component: () => import("@/views/admin/log/UpdateRightList.vue"),
          meta: { title: webTitle + " / 管理员 / 设置权限日志" },
        },
        {
          name: "LogMemberUpdatePlaceList",
          path: "/log-member-update-place-list",
          component: () => import("@/views/admin/log/UpdatePlaceList.vue"),
          meta: { title: webTitle + " / 管理员 / 设置站点日志" },
        },
        {
          name: "LogMemberUpdateSerialList",
          path: "/log-member-update-serial-list",
          component: () => import("@/views/admin/log/UpdateSerialList.vue"),
          meta: { title: webTitle + " / 管理员 / 更新序列号日志" },
        },
      ],
      meta: { title: webTitle + " / 管理员" },
    },

    /**系统*/
    {
      name: "sys-login",
      path: "/sys-login",
      component: () => import("@/views/sys/login/LoginPage.vue"),
      meta: { title: webTitle + " / 系统管理" },
    },
    {
      name: "sys-index",
      path: "/sys-index",
      component: () => import("@/views/sys/index/IndexPage.vue"),
      children: [
        {
          name: "sys-user-view",
          path: "/sys-user-view",
          component: () => import("@/views/sys/user/UserView.vue"),
          meta: { title: webTitle + " / 系统管理 / 基本信息" },
        }, //,meta:{keepAlive:true,isBack:false}
        {
          name: "sys-member-list",
          path: "/sys-member-list",
          component: () => import("@/views/sys/member/MemberList.vue"),
          meta: { title: webTitle + " / 系统管理 / 客户信息" },
        },
        {
          name: "SysPlaceList",
          path: "/sys-place-list",
          component: () => import("@/views/sys/place/PlaceList.vue"),
          meta: { title: webTitle + " / 系统管理 / 站点信息" },
        },
         {
          name: "SysRechargeList",
          path: "/sys-recharge-list",
          component: () => import("@/views/sys/recharge/RechargeList.vue"),
          meta: { title: webTitle + " / 系统管理 / 费用充值" },
        },
         {
          name: "sys-text-list",
          path: "/sys-text-list",
          component: () => import("@/views/sys/text/TextList.vue"),
          meta: { title: webTitle + " / 系统管理 / 设置短信" },
        },
        {
          name: "sys-node-list",
          path: "/sys-node-list",
          component: () => import("@/views/sys/node/NodeList.vue"),
          meta: { title: webTitle + " / 系统管理 / 栏目信息" },
        },        
        {
          name: "sys-field-list",
          path: "/sys-field-list",
          component: () => import("@/views/sys/field/FieldList.vue"),
          meta: { title: webTitle + " / 系统管理 / 字段设置" },
        },
        {
          name: "sys-log-login",
          path: "/sys-log-login",
          component: () => import("@/views/sys/log/LoginList.vue"),
          meta: { title: webTitle + " / 系统管理 / 登录日志" },
        },
        {
          name: "sys-member-user-list",
          path: "/sys-member-user-list",
          component: () => import("@/views/sys/memberuser/MemberUserList.vue"),
          meta: { title: webTitle + " / 系统管理 / 客户用户" },
        },

        {
          name: "sys-index-mili-index-insurance-register-list",
          path: "/sys-index-mili-index-insurance-register-list",
          component: () => import("@/views/sys/mili/InsuranceRegisterList.vue"),
          meta: { title: webTitle + " / 系统管理 / 米粒保险" },
        },

      ],
      meta: { title: webTitle + " / 管理员" },
    },

    /**工作*/
    {
      name: "index-page",
      path: "/index-page",
      component: () => import("@/views/IndexPage.vue"),
      children: [
        /**工作台*/
        {
          name: "home-page",
          path: "/home-page",
          component: () => import("@/views/HomePage.vue"),
          //component: () => import('@/views/TempPage2.vue'),
          meta: { title: webTitle + " / 工作台" },
        },

                /**移动页面菜单*/
                {
                  name: "mobile-side-bar",
                  path: "/mobile-side-bar",
                  component: () => import("@/components/MobileSideBar.vue"),
                  meta: { title: webTitle + "/ 菜单" },
                },
        

        /**参数管理*/
        {
          name: "param-template-set-list",
          path: "/param-template-set-list/:id",
          component: () => import("@/views/works/param/template/SetList.vue"),
          meta: { title: webTitle + " / 参数管理 / 模板设置" },
        },
        {
          name: "param-template-use-list",
          path: "/param-template-use-list/:id",
          component: () => import("@/views/works/param/template/UseList.vue"),
          meta: { title: webTitle + " / 参数管理 / 模板使用" },
        },
        {
          name: "param-send-list",
          path: "/param-send-list/:id",
          component: () => import("@/views/works/param/send/SendList.vue"),
          meta: { title: webTitle + " / 参数管理 / 发货方" },
        },
        {
          name: "param-receive-list",
          path: "/param-receive-list/:id",
          component: () =>
            import("@/views/works/param/receive/ReceiveList.vue"),
          meta: { title: webTitle + " / 参数管理 / 收货方" },
        },
        {
          name: "param-car-list",
          path: "/param-car-list/:id",
          component: () => import("@/views/works/param/car/CarList.vue"),
          meta: { title: webTitle + " / 参数管理 / 运输车辆" },
        },
        {
          name: "param-carrier-network-list",
          path: "/param-carrier-network-list/:id",
          component: () =>
            import("@/views/works/param/carrier/CarrierNetworkList.vue"),
          meta: { title: webTitle + " / 参数管理 / 承运商网点" },
        },
        {
          name: "param-sign-in-list",
          path: "/param-sign-in-list/:id",
          component: () => import("@/views/works/param/signin/SignInList.vue"),
          meta: { title: webTitle + " / 参数管理 / 签收参数" },
        },
        {
          name: "param-class-list",
          path: "/param-class-list/:id",
          component: () => import("@/views/works/param/class/ClassList.vue"),
          meta: { title: webTitle + " / 参数管理 / 参数分类" },
        },
        {
          name: "param-fee-class-list",
          path: "/param-fee-class-list/:id",
          component: () => import("@/views/works/param/fee/FeeClassList.vue"),
          meta: { title: webTitle + " / 参数管理 / 费用分类" },
        },
        {
          name: "param-number-list",
          path: "/param-number-list/:id",
          component: () => import("@/views/works/param/number/NumberList.vue"),
          meta: { title: webTitle + " / 参数管理 / 单号设置" },
        },

        /**业务管理-公共查询*/
        {
          name: "query-index",
          path: "/query-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 业务管理 / 公共查询",
          },
          children: [
            {
              name: "query-index-order-list",
              path: "/query-index/order-list/:id",
              component: () =>
                import("@/views/works/business/query/OrderList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 托单信息",
                activeMenu: "/query-index",
              },
            },
            {
              name: "query-index-track-list",
              path: "/query-index/track-list/:id",
              component: () =>
                import("@/views/works/business/query/TrackList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 跟踪信息",
                activeMenu: "/query-index",
              },
            },
            {
              name: "query-index-long-list",
              path: "/query-index/long-list/:id",
              component: () =>
                import("@/views/works/business/query/LongList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 干线清单",
                activeMenu: "/query-index",
              },
            },
            {
              name: "query-index-long-fee-list",
              path: "/query-index/long-fee-list/:id",
              component: () =>
                import("@/views/works/business/query/LongFeeList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 干线往来费用",
                activeMenu: "/query-index",
              },
            },
            {
              name: "query-index-arrive-place-not-operated-list",
              path: "/query-index/arrive-place-not-operated-list/:id",
              component: () =>
                import(
                  "@/views/works/business/query/ArrivePlaceNotOperatedList.vue"
                ),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 到站未操作",
                activeMenu: "/query-index",
              },
            },
            {
              name: "query-index-abnormal-list",
              path: "/query-index-abnormal-list/:id",
              component: () =>
                import(
                  "@/views/works/business/query/AbnormalList.vue"
                ),
              meta: {
                title: webTitle + " / 业务管理 / 公共查询 / 异常信息",
                activeMenu: "/query-index",
              },
            },
          ],
        },

        /**业务管理-托单管理*/
        {
          name: "order-index",
          path: "/order-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 业务管理 / 托单管理",
          },
          children: [
            {
              name: "order-index-order-add",
              path: "/order-index/order-add/:id",
              component: () =>
                import("@/views/works/business/order/OrderAdd.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 托单管理 / 新增托单",
                activeMenu: "/order-index",
              },
            },
            
            {
              name: "order-index-order-stock",
              path: "/order-index/order-stock/:id",
              component: () =>
                import("@/views/works/business/order/OrderStock.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 托单管理 / 库存托单",
                activeMenu: "/order-index",
              },
            },
            {
              name: "order-list",
              path: "/order-index/order-list/:id",
              component: () =>
                import("@/views/works/business/order/OrderList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 托单管理 / 修改托单",
                activeMenu: "/order-index",
              },
            },
            {
              name: "order-index-order-add2",
              path: "/order-index/order-add2/:id",
              component: () =>
                import("@/views/works/business/order/OrderAdd2.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 托单管理 / 新增托单2",
                activeMenu: "/order-index",
              },
            },
            {
              name: "order-index-order-add3",
              path: "/order-index/order-add3/:id",
              component: () =>
                import("@/views/works/business/order/OrderAdd3.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 托单管理 / 新增托单3",
                activeMenu: "/order-index",
              },
            },
            
            {
              name: "order-index-order-add4",
              path: "/order-index/order-add4/:id",
              component: () =>
                import("@/views/works/business/order/OrderAdd4.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 托单管理 / 新增托单4",
                activeMenu: "/order-index",
              },
            },
          ],
        },

        /**业务管理-货代管理*/
        {
          name: "com-base-sub-node",
          path: "/tripartite-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 业务管理 / 货代管理",
            //keepAlive:true,
            //activeMenu: '/tripartite-index',
          },
          children: [
            {
              name: "tripartite-index-tripartite-prepare",
              path: "/tripartite-index/tripartite-prepare/:id",
              component: () =>
                import(
                  "@/views/works/business/tripartite/TripartitePrepare.vue"
                ),
              meta: {
                title: webTitle + " / 业务管理 / 货代管理 / 货代发货",
                activeMenu: "/tripartite-index",
              },
            },
            {
              name: "tripartite-index-tripartite-list",
              path: "/tripartite-index/tripartite-list/:id",
              component: () =>
                import("@/views/works/business/tripartite/TripartiteList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 货代管理 / 货代清单",
                activeMenu: "/tripartite-index",
              },
            },
            {
              name: "tripartite-index-tripartite-track-prepare",
              path: "/tripartite-index/tripartite-track-prepare/:id",
              component: () =>
                import(
                  "@/views/works/business/tripartite/TripartiteTrackPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 业务管理 / 货代管理 / 货代跟踪",
                activeMenu: "/tripartite-index",
              },
            },
            {
              name: "tripartite-index-tripartite-track-list",
              path: "/tripartite-index/tripartite-track-list/:id",
              component: () =>
                import(
                  "@/views/works/business/tripartite/TripartiteTrackList.vue"
                ),
              meta: {
                title: webTitle + " / 业务管理 / 货代管理 / 跟踪信息",
                activeMenu: "/tripartite-index",
              },
            },
            // {
            //     name: 'order-log',
            //     path: '/order-index/order-log/:id',
            //     component: () => import('@/views/works/business/order/OrderUpdateLog.vue'),
            //     meta: {
            //         title: webTitle + ' / 业务管理 / 货代管理 / 修改日志',
            //         activeMenu: '/order-index/064c0fd077cd4c79926e3662e8becb52',
            //     }
            // },
          ],
        },

        /**业务管理-干线运输*/
        {
          name: "long-index",
          path: "/long-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 业务管理 / 干线运输",
            //keepAlive:true,
          },
          children: [
            {
              name: "long-index-long-list",
              path: "/long-index/long-list/:id",
              component: () =>
                import("@/views/works/business/long/LongList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 干线运输 / 干线清单",
                activeMenu: "/long-index",
              },
            },
            {
              name: "long-index-long-track-prepare",
              path: "/long-index/long-track-prepare/:id",
              component: () =>
                import("@/views/works/business/long/LongTrackPrepare.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 干线运输 / 车辆跟踪",
                activeMenu: "/long-index",
              },
            },
            {
              name: "long-index-long-track-list",
              path: "/long-index/long-track-list/:id",
              component: () =>
                import("@/views/works/business/long/LongTrackList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 干线运输 / 跟踪信息",
                activeMenu: "/long-index",
              },
            },
          ],
        },

        /**业务管理-短途运输*/
        {
          name: "short-index",
          path: "/short-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 业务管理 / 短途运输",
            //keepAlive:true,
          },
          children: [
            {
              name: "short-index-short-prepare",
              path: "/short-index/short-prepare/:id",
              component: () =>
                import("@/views/works/business/short/ShortPrepare.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 短途运输 / 单票送货",
                activeMenu: "/short-index",
              },
            },
            {
              name: "short-index-short-list",
              path: "/short-index/short-list/:id",
              component: () =>
                import("@/views/works/business/short/ShortList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 短途运输 / 短途清单",
                activeMenu: "/short-index",
              },
            },
            {
              name: "short-index-short-datail-list",
              path: "/short-index/short-detail-list/:id",
              component: () =>
                import("@/views/works/business/short/ShortDetailList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 短途运输 / 短途明细",
                activeMenu: "/short-index",
              },
            },
            {
              name: "short-index-short-pick-up-prepare",
              path: "/short-index/short-pick-up-prepare/:id",
              component: () =>
                import("@/views/works/business/short/ShortPickUpPrepare.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 短途运输 / 单票提货",
                activeMenu: "/short-index",
              },
            },
          ],
        },

        /**业务管理-中转管理*/
        {
          name: "transfer-index",
          path: "/transfer-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 业务管理 / 中转管理",
          },
          children: [
            {
              name: "transfer-index-transfer-prepare",
              path: "/transfer-index/transfer-prepare/:id",
              component: () =>
                import("@/views/works/business/transfer/TransferPrepare.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 中转管理 / 中转发货",
                activeMenu: "/transfer-index",
              },
            },
            {
              name: "transfer-index-transfer-list",
              path: "/transfer-index/transfer-list/:id",
              component: () =>
                import("@/views/works/business/transfer/TransferList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 中转管理 / 中转清单",
                activeMenu: "/transfer-index",
              },
            },
          ],
        },

        /**业务管理-签收回执*/
        {
          name: "sign-receipt-index",
          path: "/sign-receipt-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 业务管理 / 签收回执",
            //keepAlive:true,
          },
          children: [
            {
              name: "sign-in-index-sign-in-prepare",
              path: "/sign-in-index/sign-in-prepare/:id",
              component: () =>
                import("@/views/works/business/signin/SignInPrepare.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 签收回执 / 托单签收",
                activeMenu: "/sign-receipt-index",
              },
            },
            {
              name: "sign-in-index-sign-in-list",
              path: "/sign-in-index/sign-in-list/:id",
              component: () =>
                import("@/views/works/business/signin/SignInList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 签收回执 / 签收清单",
                activeMenu: "/sign-receipt-index",
              },
            },
            {
              name: "receipt-index-receipt-post-list",
              path: "/receipt-index/receipt-post-list/:id",
              component: () =>
                import(
                  "@/views/works/business/receipt/post/ReceiptPostList.vue"
                ),
              meta: {
                title: webTitle + " / 业务管理 / 签收回执 / 下线提交",
                activeMenu: "/sign-receipt-index",
              },
            },
            {
              name: "receipt-index-receipt-post-accept-prepare",
              path: "/receipt-index/receipt-post-accept-prepare/:id",
              component: () =>
                import(
                  "@/views/works/business/receipt/post/ReceiptPostAcceptPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 业务管理 / 签收回执 / 上线接收",
                activeMenu: "/sign-receipt-index",
              },
            },
            {
              name: "receipt-index-receipt-receive-prepare",
              path: "/receipt-index/receipt-receive-prepare/:id",
              component: () =>
                import(
                  "@/views/works/business/receipt/receive/ReceiptReceivePrepare.vue"
                ),
              meta: {
                title: webTitle + " / 业务管理 / 签收回执 / 发站接收回执",
                activeMenu: "/sign-receipt-index",
              },
            },
            {
              name: "receipt-index-receipt-receive-list",
              path: "/receipt-index/receipt-receive-list/:id",
              component: () =>
                import(
                  "@/views/works/business/receipt/receive/ReceiptReceiveList.vue"
                ),
              meta: {
                title: webTitle + " / 业务管理 / 签收回执 / 接收回执清单",
                activeMenu: "/sign-receipt-index",
              },
            },
            {
              name: "receipt-index-receipt-taken-not-list",
              path: "/receipt-index/receipt-taken-not-list/:id",
              component: () =>
                import(
                  "@/views/works/business/receipt/clienttaken/ReceiptClientTakenNotList.vue"
                ),
              meta: {
                title: webTitle + " / 业务管理 / 签收回执 / 客户未取走回执",
                activeMenu: "/sign-receipt-index",
              },
            },
            {
              name: "receipt-index-receipt-client-taken-list",
              path: "/receipt-index/receipt-client-taken-list/:id",
              component: () =>
                import(
                  "@/views/works/business/receipt/clienttaken/ReceiptClientTakenList.vue"
                ),
              meta: {
                title: webTitle + " / 业务管理 / 签收回执 / 客户取走回执清单",
                activeMenu: "/sign-receipt-index",
              },
            },
            {
              name: "sign-in-shortcut-check-index-sign-in-shortcut-check-prepare",
              path: "/sign-in-shortcut-check-index/sign-in-shortcut-check-prepare/:id",
              component: () =>
                import(
                  "@/views/works/business/signincheck/SignInShortcutCheckPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 业务管理 / 签收回执 / 到站签收结帐",
                activeMenu: "/sign-receipt-index",
              },
            },
          ],
        },

        /**业务管理-其他费用*/
        {
          name: "other-charges-index",
          path: "/other-charges-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 业务管理 / 其他费用",
          },
          children: [
            {
              name: "other-charges-index-order-other-charges-prepare",
              path: "/other-charges-index/order-other-charges-prepare/:id",
              component: () =>
                import(
                  "@/views/works/business/other/order/OtherChargesPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 业务管理 / 其他费用 / 新增托单费用",
                activeMenu: "/other-charges-index",
              },
            },
            {
              name: "other-charges-index-order-other-charges-list",
              path: "/other-charges-index/order-other-charges-list/:id",
              component: () =>
                import(
                  "@/views/works/business/other/order/OtherChargesList.vue"
                ),
              meta: {
                title: webTitle + " / 业务管理 / 其他费用 / 托单费用清单",
                activeMenu: "/other-charges-index",
              },
            },
            {
              name: "other-charges-index-long-other-charges-prepare",
              path: "/other-charges-index/long-other-charges-prepare/:id",
              component: () =>
                import(
                  "@/views/works/business/other/long/OtherChargesPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 业务管理 / 其他费用 / 新增干线费用",
                activeMenu: "/other-charges-index",
              },
            },
            {
              name: "other-charges-index-long-other-charges-list",
              path: "/other-charges-index/long-other-charges-list/:id",
              component: () =>
                import(
                  "@/views/works/business/other/long/OtherChargesList.vue"
                ),
              meta: {
                title: webTitle + " / 业务管理 / 其他费用 / 干线费用清单",
                activeMenu: "/other-charges-index",
              },
            },
          ],
        },

        /**业务管理-合作站点*/
        {
          name: "cooperate-index-long-fee-list",
          path: "/cooperate-index/long-fee-list/:id",
          component: () =>
            import("@/views/works/business/cooperate/long/LongFeeList.vue"),
          meta: {
            title: webTitle + " / 业务管理 / 合作站点",
          },
        },

         /**业务管理-申请修改*/
         {
          name: "ask-for-index",
          path: "/ask-for-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 业务管理 / 申请修改",
            //keepAlive:true,
            //activeMenu: '/tripartite-index',
          },
          children: [
            {
              name: "ask-for-index-ask-for-prepare",
              path: "/ask-for-index-ask-for-prepare/:id",
              component: () =>
                import("@/views/works/business/askfor/AskForPrepare.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 申请修改 / 修改",
                activeMenu: "/ask-for-index",
              },
            },
            {
              name: "ask-for-index-ask-for-list",
              path: "/ask-for-index-ask-for-list/:id",
              component: () =>
                import("@/views/works/business/askfor/AskForList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 申请修改 / 申请记录",
                activeMenu: "/ask-for-index",
              },
            },
          ],
        },

          /**业务管理-订单管理*/
          {
            name: "external-orde-index",
            path: "/external-orde-index/:id",
            component: () => import("@/components/BaseSubNode.vue"),
            meta: {
              title: webTitle + " / 业务管理 / 订单管理",
              //keepAlive:true,
              //activeMenu: '/tripartite-index',
            },
            children: [
              {
                name: "external-order-index-accept-order-prepare",
                path: "/external-order-index-accept-order-prepare/:id",
                component: () =>
                  import("@/views/works/business/externalorder/AcceptOrderPrepare.vue"),
                meta: {
                  title: webTitle + " / 业务管理 / 订单 / 接收",
                  activeMenu: "/external-orde-index",
                },
              },
              // {
              //   name: "ask-for-index-ask-for-list",
              //   path: "/ask-for-index-ask-for-list/:id",
              //   component: () =>
              //     import("@/views/works/business/askfor/AskForList.vue"),
              //   meta: {
              //     title: webTitle + " / 业务管理 / 申请修改 / 申请记录",
              //     activeMenu: "/ask-for-index",
              //   },
              // },
            ],
          },

        /**业务管理-日记帐*/
        {
          name: "day-book-index",
          path: "/day-book-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 业务管理 / 日记帐",
          },
          children: [
            {
              name: "day-book-index-day-book-add",
              path: "/day-book-index/day-book-add/:id",
              component: () =>
                import("@/views/works/business/day/DayBookAdd.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 日记帐 / 新增日记帐",
                activeMenu: "/day-book-index",
              },
            },
            {
              name: "day-book-index-day-book-list",
              path: "/day-book-index/day-book-list/:id",
              component: () =>
                import("@/views/works/business/day/DayBookList.vue"),
              meta: {
                title: webTitle + " / 业务管理 / 日记帐 / 日记帐清单",
                activeMenu: "/day-book-index",
              },
            },
          ],
        },

        /**结帐管理-发货结帐*/
        {
          name: "order-check-index",
          path: "/order-check-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 结帐管理 / 发货结帐",
          },
          children: [
            {
              name: "order-check-index-shortcut-prepare",
              path: "/order-check-index/shortcut-prepare/:id",
              component: () =>
                import(
                  "@/views/works/check/order/shortcut/ShortcutPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 发货结帐 / 快捷结帐",
                activeMenu: "/order-check-index",
              },
            },
            {
              name: "order-check-index-shortcut-list",
              path: "/order-check-index/shortcut-list/:id",
              component: () =>
                import("@/views/works/check/order/shortcut/ShortcutList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 发货结帐 / 快捷清单",
                activeMenu: "/order-check-index",
              },
            },

            {
              name: "order-check-index-bill-list",
              path: "/order-check-index/bill-list/:id",
              component: () =>
                import("@/views/works/check/order/bill/BillList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 发货结帐 / 对帐单",
                activeMenu: "/order-check-index",
              },
            },
            {
              name: "order-check-index-bill-check-prepare",
              path: "/order-check-index/bill-check-prepare/:id",
              component: () =>
                import("@/views/works/check/order/bill/BillCheckPrepare.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 发货结帐 / 帐单结帐",
                activeMenu: "/order-check-index",
              },
            },
            {
              name: "order-check-index-bill-check-list",
              path: "/order-check-index/bill-check-list/:id",
              component: () =>
                import("@/views/works/check/order/bill/BillCheckList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 发货结帐 / 结帐清单",
                activeMenu: "/order-check-index",
              },
            },
            {
              name: "order-check-index-count-no-reconcile-list",
              path: "/order-check-index/count-no-reconcile-list/:id",
              component: () =>
                import(
                  "@/views/works/check/order/count/CountNoReconcileList.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 发货结帐 / 未对帐",
                activeMenu: "/order-check-index",
              },
            },
            {
              name: "order-check-index-count-list",
              path: "/order-check-index/count-list/:id",
              component: () =>
                import("@/views/works/check/order/count/CountList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 发货结帐 / 统计",
                activeMenu: "/order-check-index",
              },
            },
          ],
        },

        /**结帐管理-干线结帐*/
        {
          name: "long-check-index",
          path: "/long-check-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 结帐管理 / 干线结帐",
          },
          children: [
            {
              name: "long-check-index-shortcut-prepare",
              path: "/long-check-index/shortcut-prepare/:id",
              component: () =>
                import("@/views/works/check/long/shortcut/ShortcutPrepare.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 干线结帐 / 快捷结帐",
                activeMenu: "/long-check-index",
              },
            },
            {
              name: "long-check-index-shortcut-list",
              path: "/long-check-index/shortcut-list/:id",
              component: () =>
                import("@/views/works/check/long/shortcut/ShortcutList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 干线结帐 / 快捷清单",
                activeMenu: "/long-check-index",
              },
            },

            {
              name: "long-check-index-bill-list",
              path: "/long-check-index/bill-list/:id",
              component: () =>
                import("@/views/works/check/long/bill/BillList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 干线结帐 / 对帐单",
                activeMenu: "/long-check-index",
              },
            },
            {
              name: "long-check-index-bill-check-prepare",
              path: "/long-check-index/bill-check-prepare/:id",
              component: () =>
                import("@/views/works/check/long/bill/BillCheckPrepare.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 干线结帐 / 帐单结帐",
                activeMenu: "/long-check-index",
              },
            },
            {
              name: "long-check-index-bill-check-list",
              path: "/long-check-index/bill-check-list/:id",
              component: () =>
                import("@/views/works/check/long/bill/BillCheckList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 干线结帐 / 结帐清单",
                activeMenu: "/long-check-index",
              },
            },
            {
              name: "long-check-index-count-no-reconcile-list",
              path: "/long-check-index/count-no-reconcile-list/:id",
              component: () =>
                import(
                  "@/views/works/check/long/count/CountNoReconcileList.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 干线结帐 / 未对帐",
                activeMenu: "/long-check-index",
              },
            },
            {
              name: "long-check-index-count-list",
              path: "/long-check-index/count-list/:id",
              component: () =>
                import("@/views/works/check/long/count/CountList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 干线结帐 / 统计",
                activeMenu: "/long-check-index",
              },
            },
          ],
        },

        /**结帐管理-短途结帐*/
        {
          name: "short-check-index",
          path: "/short-check-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 结帐管理 / 短途结帐",
          },
          children: [
            {
              name: "short-check-index-shortcut-prepare",
              path: "/short-check-index/shortcut-prepare/:id",
              component: () =>
                import(
                  "@/views/works/check/short/shortcut/ShortcutPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 短途结帐 / 快捷结帐",
                activeMenu: "/short-check-index",
              },
            },
            {
              name: "short-check-index-shortcut-list",
              path: "/short-check-index/shortcut-list/:id",
              component: () =>
                import("@/views/works/check/short/shortcut/ShortcutList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 短途结帐 / 快捷清单",
                activeMenu: "/short-check-index",
              },
            },
            {
              name: "short-check-index-bill-list",
              path: "/short-check-index/bill-list/:id",
              component: () =>
                import("@/views/works/check/short/bill/BillList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 短途结帐 / 对帐单",
                activeMenu: "/short-check-index",
              },
            },
            {
              name: "short-check-index-bill-check-prepare",
              path: "/short-check-index/bill-check-prepare/:id",
              component: () =>
                import("@/views/works/check/short/bill/BillCheckPrepare.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 短途结帐 / 帐单结帐",
                activeMenu: "/short-check-index",
              },
            },
            {
              name: "short-check-index-bill-check-list",
              path: "/short-check-index/bill-check-list/:id",
              component: () =>
                import("@/views/works/check/short/bill/BillCheckList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 短途结帐 / 结帐清单",
                activeMenu: "/short-check-index",
              },
            },
          ],
        },

        /**结帐管理-中转结帐*/
        {
          name: "transfer-check-index",
          path: "/transfer-check-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 结帐管理 / 货代中转结帐",
          },
          children: [
            {
              name: "transfer-check-index-shortcut-prepare",
              path: "/transfer-check-index/shortcut-prepare/:id",
              component: () =>
                import(
                  "@/views/works/check/transfer/shortcut/ShortcutPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 货代中转结帐 / 快捷结帐",
                activeMenu: "/transfer-check-index",
              },
            },
            {
              name: "transfer-check-index-shortcut-list",
              path: "/transfer-check-index/shortcut-list/:id",
              component: () =>
                import(
                  "@/views/works/check/transfer/shortcut/ShortcutList.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 货代中转结帐 / 快捷清单",
                activeMenu: "/transfer-check-index",
              },
            },
            {
              name: "transfer-check-index-bill-list",
              path: "/transfer-check-index/bill-list/:id",
              component: () =>
                import("@/views/works/check/transfer/bill/BillList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 货代中转结帐 / 对帐单",
                activeMenu: "/transfer-check-index",
              },
            },
            {
              name: "transfer-check-index-bill-check-prepare",
              path: "/transfer-check-index/bill-check-prepare/:id",
              component: () =>
                import(
                  "@/views/works/check/transfer/bill/BillCheckPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 货代中转结帐 / 帐单结帐",
                activeMenu: "/transfer-check-index",
              },
            },
            {
              name: "transfer-check-index-bill-check-list",
              path: "/transfer-check-index/bill-check-list/:id",
              component: () =>
                import("@/views/works/check/transfer/bill/BillCheckList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 货代中转结帐 / 结帐清单",
                activeMenu: "/transfer-check-index",
              },
            },
            {
              name: "transfer-check-index-count-no-reconcile-list",
              path: "/transfer-check-index/count-no-reconcile-list/:id",
              component: () =>
                import("@/views/works/check/transfer/count/CountNoReconcileList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 货代中转结帐 / 未对帐",
                activeMenu: "/transfer-check-index",
              },
            },
            {
              name: "transfer-check-index-count-list",
              path: "/transfer-check-index/count-list/:id",
              component: () =>
                import("@/views/works/check/transfer/count/CountList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 货代中转结帐 / 统计",
                activeMenu: "/transfer-check-index",
              },
            },
          ],
        },

        /**结帐管理-站点到付代收*/
        {
          name: "order-arrive-check-index",
          path: "/order-arrive-check-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 结帐管理 / 站点到付代收",
          },
          children: [
            {
              name: "order-arrive-check-index-shortcut-prepare",
              path: "/order-arrive-check-index/shortcut-prepare/:id",
              component: () =>
                import(
                  "@/views/works/check/orderarrive/shortcut/ShortcutPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 站点到付代收 / 快捷结帐",
                activeMenu: "/order-arrive-check-index",
              },
            },
            {
              name: "order-arrive-check-index-shortcut-list",
              path: "/order-arrive-check-index/shortcut-list/:id",
              component: () =>
                import(
                  "@/views/works/check/orderarrive/shortcut/ShortcutList.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 站点到付代收 / 快捷清单",
                activeMenu: "/order-arrive-check-index",
              },
            },

            {
              name: "order-arrive-check-index-bill-list",
              path: "/order-arrive-check-index/bill-list/:id",
              component: () =>
                import("@/views/works/check/orderarrive/bill/BillList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 站点到付代收 / 对帐单",
                activeMenu: "/order-arrive-check-index",
              },
            },
            {
              name: "order-arrive-check-index-bill-check-prepare",
              path: "/order-arrive-check-index/bill-check-prepare/:id",
              component: () =>
                import(
                  "@/views/works/check/orderarrive/bill/BillCheckPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 站点到付代收 / 帐单结帐",
                activeMenu: "/order-arrive-check-index",
              },
            },
            {
              name: "order-arrive-check-index-bill-check-list",
              path: "/order-arrive-check-index/bill-check-list/:id",
              component: () =>
                import(
                  "@/views/works/check/orderarrive/bill/BillCheckList.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 站点到付代收 / 结帐清单",
                activeMenu: "/order-arrive-check-index",
              },
            },
          ],
        },

        /**结帐管理-干线到付结帐*/
        {
          name: "long-arrive-check-index",
          path: "/long-arrive-check-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 结帐管理 / 干线到付结帐",
          },
          children: [
            {
              name: "long-arrive-check-index-shortcut-prepare",
              path: "/long-arrive-check-index/shortcut-prepare/:id",
              component: () =>
                import(
                  "@/views/works/check/longarrive/shortcut/ShortcutPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 干线到付结帐 / 快捷结帐",
                activeMenu: "/long-arrive-check-index",
              },
            },
            {
              name: "long-arrive-check-index-shortcut-list",
              path: "/long-arrive-check-index/shortcut-list/:id",
              component: () =>
                import(
                  "@/views/works/check/longarrive/shortcut/ShortcutList.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 干线到付结帐 / 快捷清单",
                activeMenu: "/long-arrive-check-index",
              },
            },

            {
              name: "long-arrive-check-index-bill-list",
              path: "/long-arrive-check-index/bill-list/:id",
              component: () =>
                import("@/views/works/check/longarrive/bill/BillList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 干线到付结帐 / 对帐单",
                activeMenu: "/long-arrive-check-index",
              },
            },
            {
              name: "long-arrive-check-index-bill-check-prepare",
              path: "/long-arrive-check-index/bill-check-prepare/:id",
              component: () =>
                import(
                  "@/views/works/check/longarrive/bill/BillCheckPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 干线到付结帐 / 帐单结帐",
                activeMenu: "/long-arrive-check-index",
              },
            },
            {
              name: "long-arrive-check-index-bill-check-list",
              path: "/long-arrive-check-index/bill-check-list/:id",
              component: () =>
                import("@/views/works/check/longarrive/bill/BillCheckList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 干线到付结帐 / 结帐清单",
                activeMenu: "/long-arrive-check-index",
              },
            },
          ],
        },

        /**结帐管理-托单其他结帐*/
        {
          name: "order-other-check-index",
          path: "/order-other-check-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 结帐管理 / 托单其他结帐",
          },
          children: [
            {
              name: "order-other-check-index-shortcut-prepare",
              path: "/order-other-check-index/shortcut-prepare/:id",
              component: () =>
                import(
                  "@/views/works/check/orderother/shortcut/ShortcutPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 托单其他结帐 / 快捷结帐",
                activeMenu: "/order-other-check-index",
              },
            },
            {
              name: "order-other-check-index-shortcut-list",
              path: "/order-other-check-index/shortcut-list/:id",
              component: () =>
                import(
                  "@/views/works/check/orderother/shortcut/ShortcutList.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 托单其他结帐 / 快捷清单",
                activeMenu: "/order-other-check-index",
              },
            },

            {
              name: "order-other-check-index-bill-list",
              path: "/order-other-check-index/bill-list/:id",
              component: () =>
                import("@/views/works/check/orderother/bill/BillList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 托单其他结帐 / 对帐单",
                activeMenu: "/order-check-index",
              },
            },
            {
              name: "order-other-check-index-bill-check-prepare",
              path: "/order-other-check-index/bill-check-prepare/:id",
              component: () =>
                import(
                  "@/views/works/check/orderother/bill/BillCheckPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 托单其他结帐 / 帐单结帐",
                activeMenu: "/order-check-index",
              },
            },
            {
              name: "order-other-check-index-bill-check-list",
              path: "/order-other-check-index/bill-check-list/:id",
              component: () =>
                import("@/views/works/check/orderother/bill/BillCheckList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 托单其他结帐 / 结帐清单",
                activeMenu: "/order-check-index",
              },
            },
          ],
        },

        /**结帐管理-整车其他结帐*/
        {
          name: "long-other-check-index",
          path: "/long-other-check-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 结帐管理 / 整车其他结帐",
          },
          children: [
            {
              name: "long-other-check-index-shortcut-prepare",
              path: "/long-other-check-index/shortcut-prepare/:id",
              component: () =>
                import(
                  "@/views/works/check/longother/shortcut/ShortcutPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 整车其他结帐 / 快捷结帐",
                activeMenu: "/long-other-check-index",
              },
            },
            {
              name: "long-other-check-index-shortcut-list",
              path: "/long-other-check-index/shortcut-list/:id",
              component: () =>
                import(
                  "@/views/works/check/longother/shortcut/ShortcutList.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 整车其他结帐 / 快捷清单",
                activeMenu: "/long-other-check-index",
              },
            },

            {
              name: "long-other-check-index-bill-list",
              path: "/long-other-check-index/bill-list/:id",
              component: () =>
                import("@/views/works/check/longother/bill/BillList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 整车其他结帐 / 对帐单",
                activeMenu: "/long-check-index",
              },
            },
            {
              name: "long-other-check-index-bill-check-prepare",
              path: "/long-other-check-index/bill-check-prepare/:id",
              component: () =>
                import(
                  "@/views/works/check/longother/bill/BillCheckPrepare.vue"
                ),
              meta: {
                title: webTitle + " / 结帐管理 / 整车其他结帐 / 帐单结帐",
                activeMenu: "/long-check-index",
              },
            },
            {
              name: "long-other-check-index-bill-check-list",
              path: "/long-other-check-index/bill-check-list/:id",
              component: () =>
                import("@/views/works/check/longother/bill/BillCheckList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 整车其他结帐 / 结帐清单",
                activeMenu: "/long-check-index",
              },
            },
          ],
        },

        /**其他费用-其他收支*/
        {
          name: "other-income-expenses-index",
          path: "/other-income-expenses-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 其他费用 / 其他收支",
          },
          children: [
            {
              name: "other-income-expenses-index-other-income-expenses-add",
              path: "/other-income-expenses-index/other-income-expenses-add/:id",
              component: () =>
                import("@/views/works/cost/other/OtherIncomeExpensesAdd.vue"),
              meta: {
                title: webTitle + " / 其他费用 / 其他收支 / 新增",
                activeMenu: "/other-income-expenses-index",
              },
            },
            {
              name: "other-income-expenses-index-other-income-expenses-list",
              path: "/other-income-expenses-index/other-income-expenses-list/:id",
              component: () =>
                import("@/views/works/cost/other/OtherIncomeExpensesList.vue"),
              meta: {
                title: webTitle + " / 其他费用 / 其他收支 / 清单",
                activeMenu: "/other-income-expenses-index",
              },
            },
          ],
        },

        /**其他费用-自有车辆*/
        {
          name: "owning-car-index",
          path: "/owning-car-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 其他费用 / 自有车辆",
          },
          children: [
            {
              name: "owning-car-index-owning-car-add",
              path: "/owning-car-index/owning-car-add/:id",
              component: () =>
                import("@/views/works/cost/car/OwningCarAdd.vue"),
              meta: {
                title: webTitle + " / 其他费用 / 自有车辆 / 新增费用",
                activeMenu: "/owning-car-index",
              },
            },
            {
              name: "owning-car-index-owning-car-list",
              path: "/owning-car-index/owning-car-list/:id",
              component: () =>
                import("@/views/works/cost/car/OwningCarList.vue"),
              meta: {
                title: webTitle + " / 其他费用 / 自有车辆 / 费用清单",
                activeMenu: "/owning-car-index",
              },
            },
          ],
        },

         /**其他费用-员工工资*/
         {
          name: "salary-index",
          path: "/salary-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 其他费用 / 员工工资",
          },
          children: [
            {
              name: "salary-index-staff-list",
              path: "/salary-index-staff-list/:id",
              component: () =>
                import("@/views/works/cost/salary/StaffList.vue"),
              meta: {
                title: webTitle + " / 其他费用 / 员工工资 / 员工信息",
                activeMenu: "/salary-index",
              },
            },
            {
              name: "salary-index-salary-list",
              path: "/salary-index-salary-list/:id",
              component: () =>
                import("@/views/works/cost/salary/SalaryList.vue"),
              meta: {
                title: webTitle + " / 其他费用 / 员工工资 / 费用信息",
                activeMenu: "/salary-index",
              },
            },
          ],
        },

        /**其他费用-期初余额*/
        {
          name: "opening-balance-index",
          path: "/opening-balance-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 其他费用 / 期初余额",
          },
          children: [
            {
              name: "opening-balance-index-opening-balance-add",
              path: "/opening-balance-index/opening-balance-add/:id",
              component: () =>
                import("@/views/works/cost/balance/OpeningBalanceAdd.vue"),
              meta: {
                title: webTitle + " / 其他费用 / 期初余额 / 新增",
                activeMenu: "/opening-balance-index",
              },
            },
            {
              name: "opening-balance-index-opening-balance-list",
              path: "/opening-balance-index/opening-balance-list/:id",
              component: () =>
                import("@/views/works/cost/balance/OpeningBalanceList.vue"),
              meta: {
                title: webTitle + " / 其他费用 / 期初余额 / 清单",
                activeMenu: "/opening-balance-index",
              },
            },
          ],
        },


        /**统计报表-托单统计*/
        {
          name: "count-report-order-index",
          path: "/count-report-order-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 统计报表 / 托单统计",
          },
          children: [
            {
              name: "count-report-order-index-report-order-list",
              path: "/count-report-order-index-report-order-list/:id",
              component: () =>import("@/views/works/count/order/ReportList.vue"),
              meta: {
                title: webTitle + " / 统计报表 / 托单统计 / 发货托单",
                activeMenu: "/count-report-order-index",
              },
            },
            {
              name: "count-report-order-index-report-transfer-list",
              path: "/count-report-order-index-report-transfer-list/:id",
              component: () =>import("@/views/works/count/transfer/ReportTransferList.vue"),
              meta: {
                title: webTitle + " / 统计报表 / 托单统计 / 货代中转",
                activeMenu: "/count-report-order-index",
              },
            },
          ],
        },
        /**统计报表-干线统计*/
        {
          name: "count-report-long-report-list",
          path: "/count-report-long-report-list/:id",
          component: () => import("@/views/works/count/long/ReportList.vue"),
          meta: { title: webTitle + " / 统计报表 / 干线统计" },
        },
        /**统计报表-流水统计*/
        {
          name: "count-report-flow-index",
          path: "/count-report-flow-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: {
            title: webTitle + " / 统计报表 / 流水统计",
          },
          children: [
            {
              name: "count-report-flow-index-report-month-list",
              path: "/count-report-flow-index/report-month-list/:id",
              component: () =>
                import("@/views/works/count/flow/ReportMonthList.vue"),
              meta: {
                title: webTitle + " / 统计报表 / 流水统计 / 月统计",
                activeMenu: "/count-report-flow-index",
              },
            },
            // {
            //     name: 'count-report-flow-index-report-day',
            //     path: '/count-report-flow-index/report-day/:id',
            //     component: () => import('@/views/works/count/flow/ReportDay.vue'),
            //     meta: {
            //         title: webTitle + ' / 统计报表 / 流水统计 / 日统计',
            //         activeMenu: '/count-report-flow-index',
            //     }
            // },
          ],
        },
        /**统计报表-干线站点统计*/
        {
          name: "count-report-long-place-report-list",
          path: "/count-report-long-place-report-list/:id",
          component: () =>
            import("@/views/works/count/longplace/ReportList.vue"),
          meta: { title: webTitle + " / 统计报表 / 干线站点统计" },
        },
        /**统计报表-利润统计*/
        {
          name: "count-report-profit-report-info",
          path: "/count-report-profit-report-info/:id",
          component: () =>
            import("@/views/works/count/profit/ReportInfo.vue"),
          meta: { title: webTitle + " / 统计报表 / 利润统计" },
        },
        /**统计报表-操作日志*/
        {
          name: "count-report-change-report-list",
          path: "/count-report-change-report-list/:id",
          component: () => import("@/views/works/count/change/ReportList.vue"),
          meta: { title: webTitle + " / 统计报表 / 操作日志" },
        },


        /**增值服务 */
        /**增值服务-整车发送短信*/
        {
          name: "additional-index-send-text-long-prepare-list",
          path: "/additional-index-send-text-long-prepare-list/:id",
          component: () => import("@/views/works/additional/text/SendTextLongPrepareList.vue"),
          meta: { title: webTitle + " / 增值服务 / 整车发送短信" },
        },

        /**增值服务-短信记录*/
        {
          name: "additional-index-send-text-list",
          path: "/additional-index-send-text-list/:id",
          component: () => import("@/views/works/additional/text/SendTextList.vue"),
          meta: { title: webTitle + " / 增值服务 / 短信记录" },
        },
      ],
    },
  ],
});

//路由守卫
router.beforeEach((to, from) => {
  if (storage.getItem("session", "basic", "token") != undefined) {
    //const user: UserInfo = JSON.parse(new Tool().FormatToken(localStorage["token"]))
    //const expDate = toolObj.FormatDate(user.exp)
    //const currDate = toolObj.GetDate()
    if (to.path === "/login") {
      // if (expDate >= currDate) {
      //     return { path: "/desktop" }
      // } else {
      //     toolObj.ClearLocalStorage()
      // }
    } else {
      // if (expDate < currDate) {
      //     toolObj.ClearLocalStorage()
      //     return { path: "/login" }
      // }
    }
  } else {
    //避免无限重定向，因此要做个判断
    if (to.path !== "/login") {
      //console.log('路由守卫',to.path)
      return { path: "/login" };
    }
  }
});

/**
 * 路由守卫，如果不是系统链接，返回到登录界面
 * 加上权限控制（考虑是否加权限）
 */
router.afterEach((to, from) => {
  //把菜单名称赋值给页面title
  window.document.title = to.meta.title as any;

  // let userId=''
  // try
  // {
  //     userId= storage.getItem('session', 'basic', 'userid')
  //     if(!isNull(userId))
  //     {
  //         //router.replace({ path: '/login' })
  //     }
  //     else {
  //         //避免无限重定向，因此要做个判断
  //         if (to.path !== "/login") {
  //             return { path: "/login" }
  //         }
  //     }
  //     console.log('用户id',userId)
  // }
  // catch(e)
  // {
  //     router.replace({ path: '/login' })
  // }

  if (from.path === "/") {
    //页面刷新不跳转
    if (window.performance.navigation.type == 1) {
      //console.log("页面被刷新")
    } else {
      router.replace({ path: "/login" });
    }
  } else {
    //如果没有权限，跳转到login
  }
  //console.log("打印from", to);
});

export default router;
